export var IMPORT_ESTIMATION_FOLDER_CLS_OPENED_KEY = 'IMPORT_ESTIMATION_FOLDER_CLS_OPENED_KEY';
export var PANEL_WIDTH = 600;
export var emptyGroupingCondition = {
  groupName: '',
  name: '',
  conditionElementPropertyId: 0,
  order: 0
};